import {
  ChatModule,
  ChatState,
  ChatMutationTree,
  ChatActionTree,
  ChatGetterTree,
} from '@/store/@types/chat';

const state: ChatState = {
  isChatOpen: false,
  messages: [],
};

const mutations: ChatMutationTree = {
  SET_IS_CHAT_OPEN(state, isOpen) {
    state.isChatOpen = isOpen;
  },

  SET_MESSAGES(state, messages) {
    state.messages = messages;
  },
};

const actions: ChatActionTree = {
  setIsChatOpen({ commit }, isOpen) {
    commit('SET_IS_CHAT_OPEN', isOpen);
  },

  setMessages({ commit }, messages) {
    commit('SET_MESSAGES', messages);
  },
};

const getters: ChatGetterTree = {
  isChatOpen: (state) => state.isChatOpen,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as ChatModule;
